module.exports = __webpack_public_path__ + "static/media/Cetak.698dca26.svg";